import { FormattedMessage, injectIntl } from "react-intl";
import { v4 as uuid } from "uuid";
import { formatAddress } from "../../utils";
import VatPrefixes from "../../constants/VatPrefix";
import { addressShape } from "../../shapes/addressShapes";
import { Details, DetailsItem } from "../Details";

type Props = {
  billingAddress: addressShape;
  shippingAddress?: addressShape;
  customerPurchaseOrder?: string;
};

export function SubscriptionBillingDetails({
  billingAddress,
  shippingAddress,
  customerPurchaseOrder,
}: Props) {
  const billingAddressDisplayed = billingAddress;
  const shippingAddressDisplayed = shippingAddress;
  const vatRequired =
    (VatPrefixes as $TSFixMe).forCountryCode(
      billingAddressDisplayed.countryCode,
    ) !== "";
  const renderedShippingAddress = shippingAddressDisplayed ? (
    <ul className="shipping-billing-address">
      {/* @ts-expect-error TS(7006) FIXME: Parameter 'line' implicitly has an 'any' type. */}
      {formatAddress(shippingAddressDisplayed).map((line) => (
        <li className="shipping-billing-line" key={uuid()}>
          {line}
        </li>
      ))}
    </ul>
  ) : (
    <div>
      <FormattedMessage id="address.shipping_is_billing_address" />
    </div>
  );

  const renderVatNumber = vatRequired ? (
    <DetailsItem
      id="subscription-vat-number"
      translationKey="label.vat_number"
      value={`${(VatPrefixes as $TSFixMe).forCountryCode(billingAddressDisplayed.countryCode)}${billingAddressDisplayed.vatNumber}`}
    />
  ) : null;

  return (
    <div className="row">
      <div className="col-md-6">
        <Details>
          <DetailsItem
            id="subscription-billing-address"
            translationKey="subscription.billing_address.header"
          >
            <ul className="shipping-billing-address">
              {/* @ts-expect-error TS(7006) FIXME: Parameter 'line' implicitly has an 'any' type. */}
              {formatAddress(billingAddressDisplayed).map((line) => (
                <li className="shipping-billing-line" key={uuid()}>
                  {line}
                </li>
              ))}
            </ul>
          </DetailsItem>
          {renderVatNumber}
          <DetailsItem
            id="subscription-purchase-order"
            translationKey="label.customer_purchase_order"
            value={customerPurchaseOrder}
          />
          <DetailsItem
            id="subscription-shipping-address"
            translationKey="subscription.shipping_address.header"
          >
            {renderedShippingAddress}
          </DetailsItem>
        </Details>
      </div>
    </div>
  );
}

// @ts-expect-error TS(2769) FIXME: No overload matches this call.
export default injectIntl(SubscriptionBillingDetails);
